import clsx from "clsx";
import styles from "./Section.module.scss";
import { Typography } from "@/frontend/shared/ui/Typography";
import { ReactNode, SVGProps } from "react";
import { CheckIcon } from "@/frontend/shared/assets/icons";

export type TSectionProps = {
  icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  itemName: string;
  description: string;
  isActive: boolean;
  isPassed: boolean;
};

export function Section({ icon: Icon, itemName, description, isActive, isPassed }: TSectionProps) {
  const icon = isPassed ? (
    <div className={styles.passedIconBlock}>
      <CheckIcon />
    </div>
  ) : (
    <div className={clsx(styles.iconBlock, isActive && styles.activeIconBlock)}>
      <Icon />
    </div>
  );

  return (
    <div className={styles.section}>
      {icon}
      <div className={styles.textBlock}>
        <Typography variant="label-5">{itemName}</Typography>
        <Typography variant="body-3">{description}</Typography>
      </div>
    </div>
  );
}
